module.exports = __webpack_public_path__ + "static/media/ic_canvas_white.64c12a9c.svg";